import { useMutation } from "@tanstack/react-query";
import { unitScanUpdate } from "common/api/citajteo/dl_unit/dl_unit_edit";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseUnitScanUpdateParams = {
  invalidateKeys?: string[];
  successHandle?: Function;
  errorHandle?: Function;
};

export const useUnitScanUpdate = (hookParams?: UseUnitScanUpdateParams) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: unitScanUpdateMutate } = useMutation({
    mutationFn: async (params: { unitId: string; fileNames: string[] }) => {
      const response = await unitScanUpdate(params.unitId, params.fileNames);

      if (!response) {
        throw new Error("unitScanUpdate failed");
      }

      return response;
    },
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }

      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
    onError: (error) => {
      if (hookParams?.errorHandle) {
        hookParams.errorHandle(error);
      }
    },
  });

  return { unitScanUpdateMutate };
};
